<template>
  <div>
    <div
      v-if="link"
      class="link"
    >
      <jade-text variant="heading-xsmall">
        {{ $t('link', { link: formattedLink }) }}
      </jade-text>
      <jade-button
        class="copy"
        size="small"
        variant="neutral-subtle"
        @click="copyToClipboard(link)"
      >
        {{ $t(copiedText) }}
      </jade-button>
      <spinner
        :timeoutInMs="FIVE_MINUTES_IN_MS"
        @expired="reset"
      />
    </div>
    <div
      v-if="$slots.trail"
      class="trail"
    >
      <slot name="trail" />
      <jade-button
        variant="primary-solid"
        size="medium"
        @click="generateLink"
        :loading="loading"
        :disabled="isButtonDisabled"
      >
        {{ $t('generate-link') }}
      </jade-button>
    </div>
    <jade-button
      v-else
      variant="primary-solid"
      size="medium"
      @click="generateLink"
      :loading="loading"
      :disabled="isButtonDisabled"
    >
      {{ $t('generate-link') }}
    </jade-button>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import TextManager from '@/utils/text-manager.utils.js'
import JadeText from '@jade/JadeText'
import JadeButton from '@jade/JadeButton'

export default {
  name: 'GenerateLinkButton',
  data () {
    return {
      link: null,
      isCopied: false,
      loading: false,
      FIVE_MINUTES_IN_MS: 300000
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    JadeButton,
    JadeText,
    Spinner: () => import('./Spinner.vue')
  },
  computed: {
    copiedText () {
      return this.isCopied ? 'copied' : 'copy'
    },
    isButtonDisabled () {
      return this.link !== null || this.loading
    },
    formattedLink () {
      return TextManager.textToEllipsis(this.link, 24)
    }
  },
  methods: {
    ...mapActions({ generateRecipientKycLink: 'GENERATE_RECIPIENT_KYC_LINK' }),
    async generateLink () {
      this.loading = true
      this.$emit('generating')
      try {
        const res = await this.generateRecipientKycLink({
          merchantId: this.$route.params.merchant_id,
          accountId: this.$route.params.account_id,
          recipientId: this.id
        })
        this.link = res.url
        this.$emit('generated', this.link)
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    reset () {
      this.link = null
    },
    handleError (err) {
      this.$emit('error', err)
      this.link = null
    },
    copyToClipboard (link) {
      this.$copyText(link).then(() => {
        this.isCopied = true
      })
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.link {
  width: 470px;
  height: 26px;
  text-wrap: nowrap;
  display: flex;
  align-items: center;
  gap: var(--global-space-200);
  margin-bottom: var(--global-space-300);
  font-variant-numeric: tabular-nums;
}
.trail {
  display: flex;
  justify-content: center;
}
.copy {
  width: 100%;
}
</style>
<i18n>
  {
    "pt-BR": {
      "generate-link": "Criar link",
      "copy": "Copiar",
      "copied": "Copiado!",
      "link": "Link: {link}"
    },
    "en-US": {
      "generate-link": "Generate link",
      "copy": "Copy",
      "copied": "Copied!",
      "link": "Link: {link}"
    }
  }
</i18n>
